import { Section } from '../common/Section'
import { Eyebrow } from '../common/Eyebrow'
import { SplitHeading } from '../animation/SplitHeading'
import { Reveal } from '../animation/Reveal'
import { Icon } from '../common/Icon'
import { company } from '../../data/company'

export function WhyGreenbay() {
  return (
    <Section className="section bg-canvas" containerClassName="grid gap-14 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Eyebrow>Why GreenbayBio</Eyebrow>
        <SplitHeading
          as="h2"
          text="Built on soil biology, honest about the science."
          className="mt-5 font-display text-h1 font-semibold text-ink"
        />
        <p className="mt-6 max-w-md text-ink-500">
          We bring together global soil-biology, humic, botanical and moisture science — and stand behind
          exactly what our products do, with full compositions and approvals published.
        </p>
      </div>

      <div>
        <Reveal className="divide-y divide-sand-200 border-y border-sand-200" stagger={0.1} y={20}>
          {company.values.map((v, i) => (
            <div key={v.title} className="group flex gap-6 py-7 transition-colors">
              <span className="font-display text-2xl font-semibold text-brand-300 tabular-nums">
                0{i + 1}
              </span>
              <div className="flex-1">
                <div className="flex items-center gap-3">
                  <Icon name={v.icon} className="h-5 w-5 text-brand-600" />
                  <h3 className="font-display text-xl font-semibold text-ink">{v.title}</h3>
                </div>
                <p className="mt-2 max-w-xl text-[0.98rem] leading-relaxed text-ink-500">{v.body}</p>
              </div>
            </div>
          ))}
        </Reveal>

        <Reveal className="mt-10" y={16}>
          <p className="text-eyebrow font-semibold uppercase tracking-[0.18em] text-ink-500">
            Approvals across the range
          </p>
          <ul className="mt-4 flex flex-wrap gap-2.5">
            {company.certifications.map((c) => (
              <li
                key={c}
                className="inline-flex items-center gap-2 rounded-full border border-brand-200 bg-brand-50/60 px-4 py-2 text-sm font-medium text-brand-800"
              >
                <Icon name="ShieldCheck" className="h-4 w-4 text-brand-500" />
                {c.split('—')[0].trim()}
              </li>
            ))}
          </ul>
          <p className="mt-3 text-xs text-ink-500">
            Approvals vary by product — see each product page for its specific licence.
          </p>
        </Reveal>
      </div>
    </Section>
  )
}
